export const tips = [
    {
        head: "FULGA INTROIT",
        body: "I Know the blood was shed (3times), For my sake(2times), For a long time I was lost, but Jesus found me out, I know the blood was shed for my sake"
    },
    {
        head: "Our Vision",
        body: "To shine as light so that people will see and  Move away from the works of darkness and  destruction into abundant life."
    },
    {
        head: "Our Mission",
        body: "To convert mankind from idol worshipping and other satanic practices into worshipping the true God in Spirit and in Truth, and reign on earth as Christ’s ambassadors."
    },
    {
        head: "Our Core Values",
        body: "Acceptance of Christ;Love & Truth;Power of Praying & Fasting;Evangelism & Church Planting."
    },
    {
        head: "Motto",
        body: "Love & Truth"
    },
    {
        head: "Doxology",
        body: "Glory be to the Father and to the Son and to the Holy Spirit. As it was in the beginning is now and forever shall be World without end, Amen"
    },
    {
        head: "Closing Hymn",
        body: [
            'I am thine O Lord, I have heard Thy voice and it told thy love to me.',
            'But I long to rise in the arms of faith and be closer drawn to thee',
            '....................................',
            'Refrain',
            '....................................',
            'Draw me nearer, nearer blessed Lord',
            'To the cross where thou hast died.',
            'Draw me nearer, nearer blessed Lord',
            'To thy precious, bleeding side.'
        ]


    },
    {
        head: "PRAYER FOR DELIVERANCE",
        body: "Deliver me O Lord from my enemies. I flee unto thee to hide, teach me to do thy will for thou art my God, Amen. Lord all my desires are before thee and my groaning is not hidden from thee"
    },
    {
        head: "PRAYER FOR HEALING",
        body: "Heal me O Lord and I shall be healed, save me with thy blood, for thou art righteous, Amen"
    },
    {
        head: "VICTORY CREED",
        body: "Victory in the name of the Father and of the Son and of the Holy Spirit"
    }
]